import "@app/App.css";
import { Popover, PopoverContent, PopoverTrigger } from "@comps/ui/popover";
import { ObjectInfos } from "@dto/objects";
import { TW_ViewMenuButton, TW_ViewMenuButtonIcon } from "@utils/twClasses";
import { EllipsisVertical } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ViewFolderMenuAddSubItem, ViewFolderMenuDeleteItem, ViewFolderMenuNewViewItem, ViewFolderMenuRenameItem } from "./ViewFolderMenuItems";

interface ViewFolderMenuButtonProps {
  objectInfos: ObjectInfos;
  path: string;
  showIcon: boolean;
}

// Kebab menu of a personal view folder: add subfolder, rename, delete
function ViewFolderMenuButton({ objectInfos, path, showIcon }: ViewFolderMenuButtonProps) {

  const { t } = useTranslation();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const closeMenu = () => {
    setIsPopoverOpen(false);
  }

  function openMenu(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();
    setIsPopoverOpen(true);
  }

  return (
    <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
      <PopoverTrigger className={TW_ViewMenuButton} onClick={openMenu} aria-label={t("folder.menu.button.label")}>
        <EllipsisVertical className={TW_ViewMenuButtonIcon + (showIcon ? " text-gray-400" : " text-gray-100")} />
      </PopoverTrigger>
      {/* Clicks bubble through the React portal up to the folder header
          (which toggles its collapse): stop them at the popover boundary */}
      <PopoverContent className="w-max p-1" onClick={(e) => e.stopPropagation()}>
        <ul>
          <li><ViewFolderMenuNewViewItem objectInfos={objectInfos} path={path} closeMenu={closeMenu} /></li>
          <li><ViewFolderMenuAddSubItem objectInfos={objectInfos} path={path} closeMenu={closeMenu} /></li>
          <li><ViewFolderMenuRenameItem objectInfos={objectInfos} path={path} closeMenu={closeMenu} /></li>
          <li><ViewFolderMenuDeleteItem objectInfos={objectInfos} path={path} closeMenu={closeMenu} /></li>
        </ul>
      </PopoverContent>
    </Popover>
  )
}

export default ViewFolderMenuButton;
